import {
  Alert,
  AppBar,
  Box,
  Grid,
  LinearProgress,
  Paper,
  Stack,
  Toolbar,
  Typography,
} from '@mui/material'
import React, { createContext, useContext, useEffect, useState } from 'react'
import App, { TenantSettingsContext } from '../../../App'
import ClientPortalMenu from './components/Menu'
import TopBar from '../../governance/medsMx/drugbags/TopBar'
import ClientPortalTopBar from './components/TopBar'
import Dashboard from './pages/Dashboard/Dashboard'
import ContentArea from './components/ContentArea'
import API from '../../../services/API'
import Loading from '../../loading/loadingPage'
import { Route, Routes } from 'react-router-dom'
import Footer from '../../applications/referenceRequest/Footer'
import DemoSwitchButton from '../../../components/demo/DemoSwitchButton'

export const ClientPortalContext = createContext({})

const ClientPortal = () => {
  const [selectedNavMenuItem, setSelectedNavMenuItem] = useState(0)
  const [clientContact, setClientContact] = useState(null)
  const [organisation, setOrganisation] = useState(null)
  const [upcomingEvents, setUpcomingEvents] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    API.get('/client-portal/my-client-contact')
      .then((res) => {
        if (res.status === 200) {
          setClientContact(res.data.clientContact)
          setOrganisation(res.data.organisation)
          setUpcomingEvents(res.data.upcomingEvents)
        }
      })
      .catch(() => setFetchError(true))
      .finally(() => setLoading(false))
  }, [])

  return (
    <Box
      maxHeight="100vh"
      maxWidth="100vw"
      height="100vh"
      bgcolor="#B0B5B5"
      padding={1}
      display="flex"
      flexDirection="column"
    >
      {/* Demo tenants only — the portal hero card has no slim app bar, so
          the switcher floats fixed at the top right of the viewport. */}
      <DemoSwitchButton floating />
      <Box
        display="flex"
        flexDirection="column"
        flex={1}
        overflow="auto"
        alignItems="space-between"
        justifyContent="space-between"
      >
        <ClientPortalContext.Provider
          value={{
            selectedNavMenuItem,
            setSelectedNavMenuItem,
            upcomingEvents,
            organisation,
            loading,
          }}
        >
          <Grid container spacing={2}>
            <ClientPortalTopBar />
            {loading ? (
              <LinearProgress />
            ) : clientContact?.requiresApproval ? (
              <Grid item xs={12}>
                <Alert severity="info">
                  Your account is pending approval and linking with your
                  organsation. Please check again later.
                </Alert>
              </Grid>
            ) : (
              <Routes>
                <Route path="/*" element={<ContentArea />} />
              </Routes>
            )}
          </Grid>
        </ClientPortalContext.Provider>

        <Footer />
      </Box>
    </Box>
  )
}

export default ClientPortal
